import { render, staticRenderFns } from "./DisposalRecord.html?vue&type=template&id=23f7fbd3&external"
import script from "./DisposalRecord.ts?vue&type=script&lang=ts&external"
export * from "./DisposalRecord.ts?vue&type=script&lang=ts&external"
import style0 from "./DisposalRecord.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports